// pricing.tsx
import React, { Component } from 'react';
import { Box, Typography, Paper, Button, Chip, Divider, List, ListItem, ListItemIcon, ListItemText } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import "../css/home.css";
import { Link } from 'react-router-dom';

const pricingPlans = [
  {
    id: 1,
    title: "Home",
    price: "₱0",
    description: "Discover our extensive collection of games, perfect for keeping your customers entertained and coming back for more.",
    features: [
        "Full Version of RonCafeSuite",
        "Access to all features",
        "No Ads",
        "DIY",
    ],
    color: "primary.main",
    period: "/PC",
    popular: false,
    ctaText: "Get Started",
    ctaVariant: "outlined",
    path: "/download",
  },
  {
    id: 2,
    title: "Mini Cafe",
    price: "₱50", // Fixed: Added ₱ symbol for consistency
    description: "Discover our extensive collection of wallpapers, perfect for personalizing your devices and keeping your customers engaged. Go get yourself too, try to customize for customers.",
    features: [
        "Full Version of RonCafeSuite",
        "Access to all features",
        "No Ads",
        "Free Updates",
    ],
    color: "secondary.main",
    period: "/PC",
    popular: false,
    ctaText: "Get Started",
    ctaVariant: "outlined",
    path: "/download",
  },
  {
    id: 3,
    title: "Gaming Hub Cafe",
    price: "₱100",
    description: "Discover our extensive collection of wallpapers, perfect for personalizing your devices and keeping your customers engaged. Go get yourself too, try to customize for customers.",
    features: [
        "Full Version of RonCafeSuite",
        "Access to all features",
        "No Ads",
        "Free Updates",
    ],
    color: "secondary.main",
    period: "/PC",
    popular: false,
    ctaText: "Get Started",
    ctaVariant: "outlined",
    path: "/download",
  },
  {
    id: 4,
    title: "Enterprise Cafe",
    price: "Contact Us",
    description: "This is a expanded version of the mini cafe, with more features and customization options. Perfect for larger businesses and enterprises. \n- More Games\n- More Wallpapers\n- More Customization Options\n- More Admin Tools",
    features: [
        "Full Version of RonCafeSuite",
        "Customization Options Include Branding, Additional Themes, and More", // Fixed: "Additioanl" -> "Additional"
        "Access to all features",
        "No Ads",
        "Free Updates",
    ],
    color: "secondary.main",
    period: "",
    popular: false,
    ctaText: "Contact Us",
    ctaVariant: "outlined",
    path: "/download",
  }
];

class Pricing extends Component {
  override render() {
    return (
      <div className='HomePage'>
        <Box sx={{ 
          py: { xs: 2, sm: 3, md: 4 }, // Responsive padding
          px: { xs: 1, sm: 2, md: 0 }  // Add horizontal padding on mobile
        }}>
          <Typography 
            variant="h1" 
            align="center" 
            gutterBottom
            sx={{
              fontSize: {
                xs: "2rem", // Smaller on mobile
                sm: "3rem",
                md: "4rem"
              },
              fontWeight: 700,
              background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              backgroundClip: 'text',
              px: { xs: 2, sm: 0 } // Add padding on mobile
            }}
          >
            Pricing Plans
          </Typography>
          
          <Paper
            elevation={0}
            sx={{ 
              p: { xs: 2, sm: 3, md: 4 }, // Responsive padding
              bgcolor: 'background.paper', 
              borderRadius: 3, 
              border: '1px solid',
              borderColor: 'divider',
              maxWidth: 800,
              mx: 'auto',
              mb: { xs: 3, sm: 4 } // Responsive margin
            }}
          >
            <Typography 
              variant="body1" 
              align="center" 
              sx={{ 
                fontSize: { xs: '0.95rem', sm: '1.1rem' } // Responsive font size
              }}
            >
              Pick the plan that fits your needs and budget. Whether you're a small café 
              or a large enterprise, we have the right solution for you.
            </Typography>
          </Paper>

          <Box
            sx={{
              pb: { xs: 4, sm: 5, md: 6 }, // Responsive padding
              width: "100%",
              maxWidth: 1200,
              margin: "0 auto",
              display: "grid",
              gridTemplateColumns: {
                xs: "1fr", // 1 column on mobile
                sm: "repeat(2, 1fr)", // 2 columns on tablet
                md: "repeat(4, 1fr)", // 4 columns on desktop
              },
              gap: { xs: 2, sm: 3, md: 4 }, // Responsive gap
              px: { xs: 2, sm: 3, md: 0 } // Horizontal padding
            }}
          >
            {pricingPlans.map((plan) => (
              <Paper
                key={plan.id}
                elevation={plan.popular ? 8 : 3}
                sx={{
                  height: '100%',
                  bgcolor: 'background.paper',
                  borderRadius: { xs: 2, sm: 3 }, // Smaller radius on mobile
                  display: "flex",
                  flexDirection: "column",
                  p: { xs: 2.5, sm: 3, md: 4 }, // Responsive padding
                  transition: 'transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out',
                  border: plan.popular ? '2px solid' : '1px solid',
                  borderColor: plan.popular ? 'primary.main' : 'divider',
                  position: 'relative',
                  '&:hover': {
                    transform: { xs: 'none', md: 'translateY(-8px)' }, // Disable hover transform on mobile
                    boxShadow: 10,
                  },
                }}
              >
                {/* Popular Badge */}
                {plan.popular && (
                  <Chip
                    label="Most Popular"
                    color="primary"
                    size="small"
                    sx={{
                      position: 'absolute',
                      top: -12,
                      right: { xs: 16, sm: 24 }, // Responsive positioning
                      fontWeight: 600,
                      fontSize: { xs: '0.7rem', sm: '0.8rem' }
                    }}
                  />
                )}

                {/* Plan Header */}
                <Box sx={{ textAlign: 'center', mb: { xs: 2, sm: 3 } }}>
                  <Typography
                    variant="h4"
                    sx={{
                      fontWeight: 700,
                      color: 'text.primary',
                      mb: 1,
                      fontSize: { xs: '1.5rem', sm: '1.8rem', md: '2rem' } // Responsive font
                    }}
                  >
                    {plan.title}
                  </Typography>
                  
                  <Box sx={{ display: 'flex', alignItems: 'baseline', justifyContent: 'center' }}>
                    <Typography
                      variant="h2"
                      sx={{
                        fontWeight: 700,
                        color: 'primary.main',
                        fontSize: {
                          xs: "1.8rem", // Smaller on mobile
                          sm: "2.2rem",
                          md: "2.5rem"
                        }
                      }}
                    >
                      {plan.price}
                    </Typography>
                    <Typography
                      variant="body2"
                      sx={{
                        color: 'text.secondary',
                        ml: 0.5,
                        fontSize: { xs: '0.8rem', sm: '0.875rem' } // Responsive
                      }}
                    >
                      {plan.period}
                    </Typography>
                  </Box>
                  
                  <Typography
                    variant="body2"
                    sx={{
                      color: 'text.secondary',
                      mt: 1,
                      fontSize: { xs: '0.8rem', sm: '0.875rem' } // Responsive
                    }}
                  >
                    {plan.description}
                  </Typography>
                </Box>

                <Divider sx={{ my: { xs: 1.5, sm: 2 } }} />

                {/* Features List */}
                <List sx={{ flex: 1, p: 0 }}>
                  {plan.features.map((feature, index) => (
                    <ListItem key={index} sx={{ px: 0, py: { xs: 0.3, sm: 0.5 } }}>
                      <ListItemIcon sx={{ minWidth: { xs: 28, sm: 32 } }}>
                        <CheckCircleIcon 
                          sx={{ 
                            fontSize: { xs: '1rem', sm: '1.2rem' }, // Smaller on mobile
                            color: plan.popular ? 'primary.main' : 'success.main' 
                          }} 
                        />
                      </ListItemIcon>
                      <ListItemText 
                        primary={feature}
                        primaryTypographyProps={{
                          variant: 'body2',
                          sx: { 
                            color: 'text.primary',
                            fontSize: { xs: '0.8rem', sm: '0.875rem' } // Responsive
                          }
                        }}
                      />
                    </ListItem>
                  ))}
                </List>

                {/* CTA Button */}
                <Button
                  component={Link}
                  to={plan.path}
                  variant={plan.ctaVariant}
                  color="primary"
                  fullWidth
                  size="large"
                  sx={{
                    mt: { xs: 2, sm: 3 },
                    py: { xs: 1.2, sm: 1.5 }, // Responsive padding
                    textTransform: 'none',
                    fontWeight: 600,
                    fontSize: { xs: '0.875rem', sm: '1rem' }, // Responsive font
                    ...(plan.popular && {
                      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                      color: 'white',
                      '&:hover': {
                        background: 'linear-gradient(135deg, #5a6fd6 0%, #6a3f8e 100%)',
                      }
                    })
                  }}
                >
                  {plan.ctaText}
                </Button>
              </Paper>
            ))}
          </Box>
        </Box>
      </div>
    )
  }
}

export default Pricing;